import React from "react";
import { Link } from "react-router-dom";
import CouponStatusBadge from "./CouponStatusBadge";

const CouponTable = ({ coupons }) => {

    return (
        <div className="coupon-table-container">

            <table className="coupon-table">

                <thead>

                    <tr>

                        <th>Code</th>

                        <th>Title</th>

                        <th>Type</th>

                        <th>Discount</th>

                        <th>Usage</th>

                        <th>Status</th>

                        <th>Expiry</th>

                        <th>Actions</th>

                    </tr>

                </thead>

                <tbody>

                    {coupons.map((coupon) => (

                        <tr key={coupon._id}>

                            <td>
                                <strong>{coupon.code}</strong>
                            </td>

                            <td>{coupon.title}</td>

                            <td>{coupon.discountType}</td>

                            <td>
                                {coupon.discountType === "percentage"
                                    ? `${coupon.discountValue}%`
                                    : `₹${coupon.discountValue}`}
                            </td>

                            <td>
                                {coupon.usedCount} / {coupon.usageLimit}
                            </td>

                            <td>
                                <CouponStatusBadge
                                    status={coupon.status}
                                />
                            </td>

                            <td>
                                {new Date(
                                    coupon.validUntil
                                ).toLocaleDateString()}
                            </td>

                            <td>

                                <Link
                                    className="table-btn view"
                                    to={`/admin/coupons/${coupon._id}`}
                                >
                                    View
                                </Link>

                                <Link
                                    className="table-btn edit"
                                    to={`/admin/coupons/edit/${coupon._id}`}
                                >
                                    Edit
                                </Link>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>
    );
};

export default CouponTable;